export const defaultLanguage = (lang) => {
    const languages = ['ja', 'en'];

    const currentLanguage = localStorage.getItem('i18nextLng');
    if (languages.includes(currentLanguage)) {
        return currentLanguage;
    }

    if (!languages.includes(lang)) {
        lang = languages[0];
    }

    localStorage.setItem('i18nextLng', lang);
    return lang;
};
